// src/components/BackButton.js
import "../../styles/Components.css";

function BackButton({ show }) {
  if (!show) return null;

  return (
    <button
      onClick={() => window.history.back()}
      className="back-button"
    >
      ← Back
    </button>
  );
}

export default BackButton;